import { keepPreviousData, useQuery } from '@tanstack/react-query'
import {
  getPrescreenedPositions,
  type GetPrescreenedPositionsParams,
} from 'api/user/getPrescreenedPositions'
import { userPrescreenedPositionsKey } from './keys'

type UseUserPrescreenedPositionsArgs = {
  userId: number
  cursor?: string
  direction?: GetPrescreenedPositionsParams['direction']
  pageSize?: number
}

export function useUserPrescreenedPositions({
  userId,
  cursor,
  direction = 'next',
  pageSize,
}: UseUserPrescreenedPositionsArgs) {
  return useQuery({
    queryKey: userPrescreenedPositionsKey({
      userId,
      cursor,
      direction,
      pageSize,
    }),
    queryFn: () =>
      getPrescreenedPositions(userId, {
        cursor,
        direction,
        pageSize,
      }),
    enabled: !!userId,
    placeholderData: keepPreviousData,
  })
}
